import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import HeroBasic, {
  heroBasicPanelColors,
  heroBasicSizes,
  heroBasicTitleSizes,
  heroBasicTitleTags
} from '@adv-mt/mt-hero-basic'

import HeroDealersListSelector from './hero-dealers-list-selector.js'

const BASE_CLASS = 'mt-HeroDealersList'
const IMAGE_CLASS = `${BASE_CLASS}-image`

const HeroDealersList = ({onProvinceSelected}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const APP_NAME = config.get('APP_NAME')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  const heroBasicProps = {
    title: {
      as: heroBasicTitleTags.h1,
      size: heroBasicTitleSizes.s,
      title: i18n.t(`HERO_DEALERS_LIST_TITLE_${APP_NAME}`),
      description: i18n.t(`HERO_DEALERS_LIST_DESCRIPTION_${APP_NAME}`)
    },
    size: heroBasicSizes.s,
    panelContentComponent: <HeroDealersListSelector onProvinceSelected={onProvinceSelected} />,
    backgroundColor: heroBasicPanelColors.CORPORATE
  }

  return (
    <div className={BASE_CLASS}>
      <HeroBasic {...heroBasicProps}>
        <div className={IMAGE_CLASS}>
          <AtomImage
            alt={i18n.t('HERO_DEALERS_LIST_DESCRIPTION')}
            src={`${URL_STATICS_IMAGES}${APP_NAME.toLowerCase()}/dealers-list-hero.png`}
          />
        </div>
      </HeroBasic>
    </div>
  )
}

HeroDealersList.displayName = 'HeroDealersList'
HeroDealersList.propTypes = {
  onProvinceSelected: PropTypes.func
}

export default HeroDealersList

export {HeroDealersListSelector}
